module.exports = __webpack_public_path__ + "img/domain-sale-hov.e110128d.svg";